import {AnyLayer} from 'mapbox-gl';

const layerConstructorViewBy = (): Array<AnyLayer> => [
  {
    id: 'precinct-raster',
    type: 'raster',
    source: 'precinct',
    paint: {
      'raster-opacity': 0.7
    }
  },{
    id: 'parcel-raster',
    type: 'raster',
    source: 'parcel',
    paint: {
      'raster-opacity': 0.7
    }
  },
];

const layerConstructorRedNatura = (): Array<AnyLayer> => ([
  {
    'id': 'redNatura',
    'type': 'raster',
    'source': 'redNatura',
    'paint': {
      'raster-opacity': 0.5
    }
  }
]);

const layerConstructorCatastro = (): Array<AnyLayer> => ([
  {
    'id': 'catastro',
    'type': 'raster',
    'source': 'catastro',
    'paint': {
      'raster-opacity': 0.5
    }
  }
]);

const layerConstructorProtection = (): Array<AnyLayer> => ([
  {
    'id': 'protection',
    'type': 'raster',
    'source': 'protection',
    'paint': {
      'raster-opacity': 0.5
    }
  }
]);

const layerConstructorOverlay = (overlayIds: Array<string>): Array<AnyLayer> =>
  overlayIds.map(overlay =>
    ({
      'id': overlay,
      'type': 'raster',
      'source': overlay,
      'paint': {
        'raster-opacity': 0.85
      }
    })
  );

const layerConstructor = {
  viewBy: layerConstructorViewBy,
  redNatura: layerConstructorRedNatura,
  catastro: layerConstructorCatastro,
  protection: layerConstructorProtection,
  overlay: layerConstructorOverlay
};

export default layerConstructor;